import React from "react";
import pimg1 from '../../images/logos/01burda.png'
import pimg2 from '../../images/logos/t-c-saglik-bakanligi-ucretsiz-logo-yildiz-ay-insan-figuru-9.png'
import pimg3 from '../../images/logos/Burger_King_logo_(1999–2020).svg.png'
import pimg4 from '../../images/logos/Dominos_pizza_logo.svg.png'
import pimg5 from '../../images/logos/pp.png'
import pimg6 from '../../images/logos/_b2-14062024101045.png'
import pimg7 from '../../images/logos/mainlogo.svg'
import pimg8 from '../../images/logos/cropped-Kesin__1_-removebg-preview.webp'
import SectionTitle from "../SectionTitle/SectionTitle";

const partners = [
    {
        pImg: pimg1,
    },
    {
        pImg: pimg2,
    },
    {
        pImg: pimg3,
    },
    {
        pImg: pimg4,
    },
    {
        pImg: pimg5,
    },
    {
        pImg: pimg6,
    },
    {
        pImg: pimg7,
    },
    {
        pImg: pimg8,
    },
]


const PartnerSection = (props) => {
    return (
        <section className="partners-section section-padding pt-175">
            <div className="container">
                <SectionTitle subTitle={'REFERANSLARIMIZ'} Title={'Sektörün Öncü Markalarıyla İş Birliği yapıyoruz.'} />
                <div className="row">
                    <div className="col col-xs-12">
                        <div className="partner-grids clearfix">
                            {partners.map((partner, pitem) => (
                                <div className="grid" key={pitem}>
                                    <img src={partner.pImg} alt="" />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default PartnerSection;
